import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import Basic_1864039017, { _demoInfo as Basic_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/Basic.tsx?loadDemo";
import Label_1864039017, { _demoInfo as Label_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/Label.tsx?loadDemo";
import Tooltip_1864039017, { _demoInfo as Tooltip_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/Tooltip.tsx?loadDemo";
import ComplexTooltip_1864039017, { _demoInfo as ComplexTooltip_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/ComplexTooltip.tsx?loadDemo";
import Legend_1864039017, { _demoInfo as Legend_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/Legend.tsx?loadDemo";
import LegendRight_1864039017, { _demoInfo as LegendRight_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/LegendRight.tsx?loadDemo";
import LegendTip_1864039017, { _demoInfo as LegendTip_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/LegendTip.tsx?loadDemo";
import SingleColors_1864039017, { _demoInfo as SingleColors_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/SingleColors.tsx?loadDemo";
import MultiColors_1864039017, { _demoInfo as MultiColors_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/MultiColors.tsx?loadDemo";
import Circle_1864039017, { _demoInfo as Circle_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/Circle.tsx?loadDemo";
import CircleSlice_1864039017, { _demoInfo as CircleSlice_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/CircleSlice.tsx?loadDemo";
import CircleGuide_1864039017, { _demoInfo as CircleGuide_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/CircleGuide.tsx?loadDemo";
import Select_1864039017, { _demoInfo as Select_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/Select.tsx?loadDemo";
import SelectCircleGuide_1864039017, { _demoInfo as SelectCircleGuide_1864039017_demoInfo } from "../../../../../packages/console-pie-chart/demo/SelectCircleGuide.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  Basic_1864039017,
  Basic_1864039017_demoInfo,
  Label_1864039017,
  Label_1864039017_demoInfo,
  Tooltip_1864039017,
  Tooltip_1864039017_demoInfo,
  ComplexTooltip_1864039017,
  ComplexTooltip_1864039017_demoInfo,
  Legend_1864039017,
  Legend_1864039017_demoInfo,
  LegendRight_1864039017,
  LegendRight_1864039017_demoInfo,
  LegendTip_1864039017,
  LegendTip_1864039017_demoInfo,
  SingleColors_1864039017,
  SingleColors_1864039017_demoInfo,
  MultiColors_1864039017,
  MultiColors_1864039017_demoInfo,
  Circle_1864039017,
  Circle_1864039017_demoInfo,
  CircleSlice_1864039017,
  CircleSlice_1864039017_demoInfo,
  CircleGuide_1864039017,
  CircleGuide_1864039017_demoInfo,
  Select_1864039017,
  Select_1864039017_demoInfo,
  SelectCircleGuide_1864039017,
  SelectCircleGuide_1864039017_demoInfo,
  React
};